export enum ShippingMethod {
  SPD_DELIVERR = "SPD_DELIVERR",
  SPD_EXTERNAL = "SPD_EXTERNAL",
  LTL_DELIVERR = "LTL_DELIVERR",
  LTL_EXTERNAL = "LTL_EXTERNAL",
  FTL_DELIVERR = "FTL_DELIVERR",
  FTL_EXTERNAL = "FTL_EXTERNAL",
  METRO_DELIVERR = "METRO_DELIVERR",
}
